import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Handlebars from 'handlebars';
import { SeoData } from "../../models/builderIO/types";
import SeoBranchPages from './seoBranchPages';
import SeoHomePage from './seoHomePage';

const SeoCommon: React.FC<{ 
  seoCommon: SeoData, 
  content: any, 
  templateData: any,
  isOverallPage?: boolean;
  isStatePage?: boolean;
  isBranchPage?: boolean;
}> = ({ seoCommon, content, templateData, isOverallPage, isStatePage, isBranchPage }) => {
  useEffect(() => {
    const metaTag = document.querySelector("meta[name='description']");
    if (metaTag && metaTag.parentNode) {
      metaTag.parentNode.removeChild(metaTag);
    }
  }, []);

  const renderTemplateObject = (obj: Record<string, any>): Record<string, any> => {
    const result: Record<string, any> = {};
    Object.entries(obj).forEach(([key, value]) => {
      if (typeof value === 'string') {
        result[key] = Handlebars.compile(value)(templateData);
      } else {
        result[key] = value;
      }
    });
    return result;
  };

  const renderedSeo = renderTemplateObject(seoCommon);
  
  const lansingNow = 'Lansing Building Products';
  const pageUrl = window.location.href;

  let isHomePage = false;
  if(pageUrl === `${process.env.REACT_APP_WEB_URL}/visitor`){
    isHomePage = true;
  }

  return (
    <>
      <Helmet>
        <title>{renderedSeo.title || content.data.title}</title>
        <meta name="description" content={renderedSeo.description || content.data.description} />
        <meta name="keywords" content={renderedSeo.keywords || ''} />
        <meta name="author" content={renderedSeo.author || lansingNow} />
        <meta name="publisher" content={renderedSeo.publisher || lansingNow} />
        <meta name="copyright" content={renderedSeo.copyright || '© ' + lansingNow} />
        <meta property="og:title" content={renderedSeo.title || content.data.title} />
        <meta property="og:description" content={renderedSeo.description || content.data.description} />
        <meta property="og:url" content={renderedSeo.ogurl || pageUrl} />
        <meta property="og:type" content={renderedSeo.ogtype || 'website'} />
        <meta property="og:site_name" content={renderedSeo.ogsitename || lansingNow} />
        <meta property="og:image" content={renderedSeo.ogimage || ''} />
        <link rel="canonical" href={renderedSeo.canonical || pageUrl} />
      </Helmet>

      {isHomePage && <SeoHomePage />}

      {(isOverallPage || isStatePage || isBranchPage) && (
        <SeoBranchPages
          templateData={templateData}
          isOverallPage={isOverallPage}
          isStatePage={isStatePage}
          isBranchPage={isBranchPage}
        />
      )}
    </>
  );
};

export default SeoCommon;
